// Mixora theme JS — reservado para futuras interacciones (menú móvil, filtros, etc.)
document.addEventListener('DOMContentLoaded', function () {
  console.log('Mixora theme loaded');
});
